import axios from "axios";
import {API_FE_DOMAIN, API_FE_SEND_RECOVERY_PASSWORD} from "../constants";
import {SEND_RECOVERY_PASSWORD_ERROR, SEND_RECOVERY_PASSWORD_SUCCESS} from "../reducers";
import { put, call } from 'redux-saga/effects';

export default function* sendRecoveryPasswordSaga(action) {
    try {
        let result = yield call(() => axios.post(
            API_FE_DOMAIN + API_FE_SEND_RECOVERY_PASSWORD,
            action.payload,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }
        ));

        const response = result.data;

        if (response.status === 1) {
            yield put({
                type: SEND_RECOVERY_PASSWORD_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({
                type: SEND_RECOVERY_PASSWORD_ERROR,
                payload: response.error,
            });
        }
    } catch (e) {
        console.log(e);
    }
}
